import React, { useRef, useState } from "react";
import { Row, Col } from "../../../../";
import { Form } from "../../../";
import { useFormikContext } from "formik";

export interface NameInputProps {
	isRequired: boolean;
	fieldLabel?: string;
	firstNameId?: string;
	firstNameName?: string;
	firstNameLabel?: string;
	lastNameId?: string;
	lastNameName?: string;
	lastNameLabel?: string;
	description?: string;
	autoComplete?: boolean;
	isColumn?: boolean;
	labelClear?: boolean;
	hiddenLabel?: boolean;
	handleChange?: (event: any) => void;
	resetForm?: () => void;
	confirmation?: boolean;
}

const NameInput: React.FC<NameInputProps> = ({
	fieldLabel = "Name",
	firstNameId = "firstName",
	firstNameName = "firstName",
	firstNameLabel = "First Name",
	lastNameId = "lastName",
	lastNameName = "lastName",
	lastNameLabel = "Last Name",
	description,
	isRequired,
	autoComplete = true,
	isColumn = false,
	labelClear = false,
	hiddenLabel,
	handleChange,
	resetForm,
	confirmation,
	...props
}) => {
	const lastNameRef = useRef<any>(null);
	const formikContext = useFormikContext<any>();

	return (
		<div className={`field ${confirmation ? "mt-0" : ""}`}>
			{hiddenLabel ? null : (
				<label className="field-name-label">
					<div className="field-name-label-text">
						{fieldLabel} {!isRequired && <span className="optional">- Optional</span>}
					</div>
					{labelClear && resetForm && (
						<a
							className="field-name-label-clear"
							href="#"
							onClick={(e) => {
								e.preventDefault();
								resetForm();
							}}
						>
							Not you?
						</a>
					)}
				</label>
			)}
			<div className={`m-bottom-pull p-0 ${isColumn ? "col" : "row"}`}>
				<div className={isColumn ? "width-full" : "col-sm-5"}>
					<Form.Field
						hiddenLabel
						label={firstNameLabel}
						id={firstNameId}
						name={firstNameName}
						isFieldRequired={isRequired}
						description={description}
						placeholder={"First"}
						autoComplete={autoComplete ? "given-name" : "new-off"}
						{...props}
						aria-label={"First"}
						onChange={handleChange ?? formikContext.handleChange}
					/>
				</div>
				<div className={isColumn ? "width-full" : "col-sm-7"}>
					<Form.Field
						hiddenLabel
						fieldRef={lastNameRef}
						label={lastNameLabel}
						id={lastNameId}
						name={lastNameName}
						description={description}
						placeholder={"Last"}
						autoComplete={autoComplete ? "family-name" : "new-off"}
						{...props}
						isFieldRequired
						aria-label={"Last"}
						onChange={handleChange ?? formikContext.handleChange}
					/>
				</div>
			</div>
		</div>
	);
};
export default NameInput;
